import { useTranslation as originUseTranslation } from 'next-i18next';

import type { FallbackNs, UseTranslationOptions, UseTranslationResponse } from 'react-i18next';
import type { $Tuple } from 'react-i18next/helpers';
import type { FlatNamespace, KeyPrefix } from 'i18next';

const useTranslation = <
  const Ns extends FlatNamespace | $Tuple<FlatNamespace> | undefined = undefined,
  const KPrefix extends KeyPrefix<FallbackNs<Ns>> = undefined,
>(
  ns?: Ns,
  options?: UseTranslationOptions<KPrefix>,
): UseTranslationResponse<FallbackNs<Ns>, KPrefix> => originUseTranslation(ns, options);

export default useTranslation;
